import React from 'react';
import { Typography, Paper, Stack, Box } from '@mui/material';

const SectionTitle = ({ title, children, subtitle, headerContent }) => {
  return (
    <Paper 
      elevation={0}
      sx={{ 
        p: 1.8,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        '& .MuiTypography-subtitle1': {
          fontSize: '0.9rem',
          mb: 1.5
        },
        '& .MuiTypography-subtitle2': {
          fontSize: '0.8rem',
          mb: 0.8
        }
      }}
    >
      <Stack spacing={1.8}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2
        }}>
          <Box>
            <Typography 
              variant="subtitle1" 
              sx={{
                color: '#c89e38',
                fontWeight: 'bold',
                fontSize: '1rem !important',
                lineHeight: 0.8
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography 
                variant="caption" 
                color="text.secondary"
                sx={{ 
                  display: 'block',
                  mt: 0.5
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          {headerContent}
        </Box>
        {children}
      </Stack>
    </Paper>
  );
};

export default SectionTitle; 